var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOntarioIconExit = function SvgOntarioIconExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M1.667 20Q1 20 .5 19.5T0 18.333V1.667Q0 1 .5.5T1.667 0H9.75v1.667H1.667v16.666H9.75V20zm13.5-5.139-1.195-1.194 2.834-2.834H7.083V9.167h9.667l-2.833-2.834L15.11 5.14 20 10.028z"
  })));
};
export default SvgOntarioIconExit;